import React, { Fragment } from "react";
import { useKashrutFeatureShowInProduct } from "../../hooks/useKashrutFeatureShowInProduct";
import {
  getKashrutFeature,
  getClassificationClassName,
  getProductBrandLabel,
  isShowableClassification,
  shouldShowProductBrand,
} from "./productInfoLineUtils";

/** Shared brand | weight | classification | kashrut-feature meta line. */
const ProductInfoLine = ({ product, alwaysShowBrand = false }) => {
  const rawKashrutFeature =
    product?.kosherSupervision?.[0]?.kashrutFeature ?? null;
  const dictAllowsShow = useKashrutFeatureShowInProduct(rawKashrutFeature);

  if (!product) return null;

  const kashrut = product.kosherSupervision?.[0]?.classification ?? "";
  const brandLabel = getProductBrandLabel(product);
  const showBrand = shouldShowProductBrand(product, {
    alwaysShow: alwaysShowBrand,
  });
  const featureName = getKashrutFeature(product);
  const showKashrutFeature = featureName && dictAllowsShow;
  const showClassification = isShowableClassification(kashrut);

  const segments = [];

  if (showBrand) {
    segments.push(
      <p key="brand" className="prod-brand">
        {brandLabel}
      </p>,
    );
  }

  if (product.weightDetails) {
    segments.push(
      <Fragment key="weight">
        {product.logisticsDetails?.packageQuantity > 1 && (
          <span className="prod-details">
            {product.logisticsDetails.packageQuantity} ×
          </span>
        )}
        <span className="prod-details">
          {product.weightDetails?.netContent}
        </span>
        <span className="prod-details">
          {product.weightDetails.unitOfMeasure}
        </span>
      </Fragment>,
    );
  }

  if (showClassification) {
    segments.push(
      <span key="kashrut" className={getClassificationClassName(kashrut)}>
        {kashrut}
      </span>,
    );
  }

  if (showKashrutFeature) {
    segments.push(
      <span key="feature" className="kashrut-feature">
        {featureName}
      </span>,
    );
  }

  if (!segments.length) return null;

  return (
    <div className="prod-info-line">
      {segments.map((segment, index) => (
        <Fragment key={segment.key ?? index}>
          {index > 0 && <span className="line">|</span>}
          {segment}
        </Fragment>
      ))}
    </div>
  );
};

export default ProductInfoLine;
